import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const inventoryMovementReportWidget: DashboardWidgetConfiguration = {
  widgetId: "inventory.movement-report",
  name: "Inventory movement report",
  description: "Inventory movement report using the reusable report-widget visualization.",
  apps: [
    "home",
    "inventory",
  ],
  template: "report",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "inventory.stock-events",
      ...period(30),
      select: [
        {
          type: "field",
          field: "event_type",
          as: "event_type",
        },
        {
          type: "aggregate",
          function: "sum",
          field: "quantity",
          as: "quantity",
        },
      ],
      group_by: [
        {
          field: "event_type",
        },
      ],
      order_by: [
        {
          ref: "quantity",
          direction: "desc",
        },
      ],
      limit: 8,
    },
  },
  inputs: {
    title: "Inventory movement report",
    subtitle: "Live RQL report",
    output: "category_series",
    visualization: "bar",
    icon: "average",
    showTimeControls: true,
  },
  dummyData: {
    value: "1,450 units",
    series: [
      18,
      30,
      24,
      42,
      35,
    ],
  },
  limits: {
    minWidth: 6,
    maxWidth: 12,
    minHeight: 3,
    maxHeight: 8,
    defaultWidth: 6,
    defaultHeight: 4,
  },
};
